import Swiper from '../../../../../vendor/swiper/swiper-bundle.mjs';

export default class ProjectSlider {
    constructor($el) {
        this.$el = $el;
        this.$next = this.$el.parentElement.querySelector('[data-next]');
        this.$prev = this.$el.parentElement.querySelector('[data-prev]');
        this.slide = this.slide.bind(this);
        this.slide();
    }

    slide() {
        var swiper = new Swiper(this.$el, {
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: this.$next,
                prevEl: this.$prev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 2,
                },
                1400: {
                    slidesPerView: 2,
                },
            }
        });
    }
}